import { createFileRoute, Outlet, redirect, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod/v4';
import { getSafeRedirectUrl } from '@hetivo/hetivo-lib-front-utils/auth';
import { useAuth } from '&/auth';

const publicSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_public')({
  beforeLoad: ({ context, search }): void => {
    if (context.auth.isAuthenticated) {
      const target = getSafeRedirectUrl(search.redirect);
      throw redirect({ to: target });
    }
  },
  component: PublicLayout,
  validateSearch: publicSearchSchema,
});

function PublicLayout(): React.JSX.Element {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { redirect: redirectParam } = Route.useSearch();

  // Reactive guard: redirect when auth state changes to authenticated
  // (e.g., after sign-in popup completes while on a public page).
  // beforeLoad only runs on navigation — this handles in-place auth state changes.
  useEffect(() => {
    if (isAuthenticated) {
      const target = getSafeRedirectUrl(redirectParam);
      void navigate({ to: target });
    }
  }, [isAuthenticated, navigate, redirectParam]);

  return <Outlet />;
}
